import React from 'react';
export default ({ isCookiedUser, view, isAutoOtp }) => {
    const isOtpCookiedView = isCookiedUser && (view === 'send_otp' || (view === 'otp_code' && isAutoOtp));
    return (React.createElement("div", { "data-testid": "paypal-logo", id: "paypalLogo", style: {
            background: 'transparent url(https://www.paypalobjects.com/paypal-ui/logos/svg/paypal-mark-color.svg) top center no-repeat',
            backgroundSize: '36px',
            width: '30px',
            height: '36px',
            display: 'block',
            margin: `${isOtpCookiedView ? '40px' : '0px'} auto`,
        } }));
};
